import { getVapidPublicKey, subscribePush, unsubscribePush } from "../services/api";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export const isPushSupported = () =>
  "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

export async function getPushSubscription() {
  if (!isPushSupported()) return null;
  const registration = await navigator.serviceWorker.ready;
  return registration.pushManager.getSubscription();
}

export async function enablePush() {
  if (!isPushSupported()) {
    throw new Error("Les notifications push ne sont pas supportées par ce navigateur");
  }
  const permission = await Notification.requestPermission();
  if (permission !== "granted") {
    throw new Error("Permission de notification refusée");
  }
  const registration = await navigator.serviceWorker.ready;
  const { data } = await getVapidPublicKey();
  const subscription = await registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(data.publicKey),
  });
  await subscribePush({ subscription: subscription.toJSON() });
  return subscription;
}

export async function disablePush() {
  const subscription = await getPushSubscription();
  if (subscription) {
    await unsubscribePush({ endpoint: subscription.endpoint });
    await subscription.unsubscribe();
  }
}
